function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  className: "alert-circle_svg__icon-stroke",
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 11
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 6.6V11M11 15.4h.011"
}));

function SvgAlertCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGcgY2xhc3M9Imljb24tc3Ryb2tlIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPgogICAgPGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iMTEiLz4KICAgIDxsaW5lIHgxPSIxMSIgeDI9IjExIiB5MT0iNi42IiB5Mj0iMTEiLz4KICAgIDxsaW5lIHgxPSIxMSIgeDI9IjExLjAxMSIgeTE9IjE1LjQiIHkyPSIxNS40Ii8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgAlertCircle as ReactComponent };